import { RadioTile, TileGroup } from '@carbon/react';

import type { SourceType } from '../types';
import styles from './select-source-step.module.scss';

export interface SourceTilesProps {
  selected: SourceType | null;
  onChange: (source: SourceType) => void;
}

/**
 * Editing a package: the From Entity and From Existing Package tiles.
 *
 * @param {SourceTilesProps} props - The picked source and the handler
 * @return {JSX.Element} The tiles
 */
export function SourceTiles({ selected, onChange }: SourceTilesProps) {
  return (
    <TileGroup
      name="package-source-type"
      valueSelected={selected ?? ''}
      onChange={(value: string | number | undefined) =>
        onChange(value as SourceType)
      }
      legend=""
      className={styles.tiles}
    >
      <RadioTile value="entity" className={styles.tile}>
        <span className={styles.tileLabel}>From Entity</span>
        <span className={styles.tileDesc}>
          Create a new package by selecting one or more entities
        </span>
      </RadioTile>
      <RadioTile value="package" className={styles.tile}>
        <span className={styles.tileLabel}>From Existing Package</span>
        <span className={styles.tileDesc}>
          Clone or combine one or more existing packages
        </span>
      </RadioTile>
    </TileGroup>
  );
}
